define('TescoMobile_Customer/js/section-top',['uiComponent', 'jquery', 'ko', 'Magento_Customer/js/customer-data', 'mage/url', 'mage/translate'], function (Component, $, ko, customerData, urlBuilder, $t) {
  'use strict';

  return Component.extend({
    isLoggedIn: ko.observable(false),
    welcome_content: ko.observable(null),
    login_content: ko.observable(null),
    login_url: ko.observable(null),
    sign_out_text: $t('<span class="sign-out">Sign out</span>'),
    welcome_text: $t('Welcome'),
    log_in_text: $t('Log in'),
    sign_out_url: urlBuilder.build('customer/account/logout'),
    log_in_url: urlBuilder.build('customer/account/login'),
    account_url: urlBuilder.build('customer/account/'),
    customerName: null,
    isDashboard: ko.observable(false),
    initialize: function () {
      this._super();
      if ($('.account.customer-account-index').length > 0) {
        this.isDashboard(true);
      }
    },
    setSectionData: function () {
      var customer = customerData.get('customer');
      if (this.customerName || customer().firstname) {
        var customerName = customer().firstname ? customer().firstname : this.customerName;
        $(".account-link-item.initial").remove();
        $("body").addClass('logged-in');
        this.isLoggedIn(true);
        this.welcome_content('<span class="welcome">' + customerName + '</span>');
        this.login_content(this.sign_out_text);
        this.login_url(this.sign_out_url);
      } else {
        $(".account-link-item.initial").remove();
        this.isLoggedIn(false);
        this.welcome_content(null);
        this.login_content(this.log_in_text);
        this.login_url(this.log_in_url);
      }
      customerData.get('customer').subscribe(function (data) {
        $(".account-link-item.initial").remove();
        if (!data.firstname) {
          this.isLoggedIn(false);
          this.welcome_content(null);
          this.login_content(this.log_in_text);
          this.login_url(this.log_in_url);
        } else {
          this.isLoggedIn(true);
          this.welcome_content('<span class="welcome">' + data.firstname + '</span>');
          this.login_content(this.sign_out_text);
          this.login_url(this.sign_out_url);
        }
      }, this);
      $('.account.customer-account-index .page-title span.base').html(function (index, html) {
        return html.slice(0, html.length - 1) + '<span>' + html.slice(html.length - 1) + '</span>';
      });
    }
  });
});

